package one.healthium.uscreen.ui.blocks

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.layout.ContentScale
import androidx.compose.ui.platform.LocalDensity
import androidx.compose.ui.platform.LocalWindowInfo
import androidx.compose.ui.platform.testTag
import androidx.compose.ui.unit.dp
import one.healthium.bundle.components.BundleImage
import one.healthium.ui.compose.theme.AppTheme
import one.healthium.uscreen.domain.models.ImageAlignment
import one.healthium.uscreen.domain.models.ImageBlock
import one.healthium.uscreen.domain.models.ImageFit
import one.healthium.uscreen.ui.util.uscreenPadding

@Composable
fun UScreenImageBlock(modifier: Modifier = Modifier, block: ImageBlock, isMale: Boolean? = null) {
    val contentScale = when (block.contentScale) {
        ImageFit.Crop -> ContentScale.Crop
        ImageFit.Fit -> ContentScale.Fit
        ImageFit.FillBounds -> ContentScale.FillBounds
        ImageFit.FillWidth -> ContentScale.FillWidth
        ImageFit.FillHeight -> ContentScale.FillHeight
        ImageFit.Inside -> ContentScale.Inside
        ImageFit.None -> ContentScale.None
    }

    val density = LocalDensity.current
    val screenHeightPx = LocalWindowInfo.current.containerSize.height
    val screenHeightDp = with(density) { screenHeightPx.toDp() }

    val heightPx = block.heightPx
    val heightPercent = block.height
    val heightModifier = when {
        heightPx != null -> Modifier.height(heightPx.dp)
        heightPercent != null -> Modifier.height(screenHeightDp * heightPercent / 100f)
        else -> Modifier
    }

    val alignment = when (block.alignment) {
        ImageAlignment.Center -> Alignment.Center
        ImageAlignment.Top -> Alignment.TopCenter
        ImageAlignment.Bottom -> Alignment.BottomCenter
        ImageAlignment.TopStart -> Alignment.TopStart
        ImageAlignment.TopEnd -> Alignment.TopEnd
        ImageAlignment.BottomStart -> Alignment.BottomStart
        ImageAlignment.BottomEnd -> Alignment.BottomEnd
        ImageAlignment.CenterStart -> Alignment.CenterStart
        ImageAlignment.CenterEnd -> Alignment.CenterEnd
    }

    val imageName = block.src.resolve(isMale)
        .substringAfterLast("/")
        .substringBeforeLast(".")

    val widthModifier = if (block.fillWidth) Modifier.fillMaxWidth() else Modifier

    BundleImage(
        modifier = modifier
            .then(widthModifier)
            .then(heightModifier)
            .uscreenPadding(block.padding, defaultHorizontal = 0)
            .testTag("uscreen_image"),
        contentScale = contentScale,
        alignment = alignment,
        name = imageName,
        placeholder = {
            Box(
                Modifier
                    .fillMaxWidth()
                    .then(heightModifier)
                    .background(AppTheme.uscreenStyle.imagePlaceholder),
            )
        },
    )
}
